/**
 * Hikari — central axios instance with JWT interceptor.
 * All frontend API calls go through this.
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('hikari_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      // Token invalid/expired — clear and let route guards handle redirect
      localStorage.removeItem('hikari_token');
      localStorage.removeItem('hikari_user');
    }
    return Promise.reject(err);
  }
);
